import { Button, Form, Space, Typography, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import type { UploadProps } from 'antd'
import { MAX_LOGO_FILE_SIZE_MB } from '../../clientFormShared'

type ClientLogoSectionProps = {
  logoUploadProps: UploadProps
  logoFileName: string
  displayedLogoUrl: string
  deleteLogoPending: boolean
  onClearPendingLogo: () => void
  onDeleteLogo: () => void | Promise<void>
}

export function ClientLogoSection({
  logoUploadProps,
  logoFileName,
  displayedLogoUrl,
  deleteLogoPending,
  onClearPendingLogo,
  onDeleteLogo,
}: ClientLogoSectionProps) {
  return (
    <Form.Item label="Logo Upload">
      <Space direction="vertical" size={6} className="w-full">
        <Upload {...logoUploadProps}>
          <Button icon={<UploadOutlined />}>Browse Logo</Button>
        </Upload>
        <Typography.Text type="secondary">
          Accepted formats: JPEG, JPG, PNG, TIFF, WEBP, BMP, or GIF. Max {MAX_LOGO_FILE_SIZE_MB}MB.
        </Typography.Text>
        {logoFileName && (
          <Space direction="vertical" size={8} className="w-fit">
            <Typography.Text type="secondary">{logoFileName}</Typography.Text>
            <Button onClick={onClearPendingLogo} className="w-fit">
              Remove Selected Logo
            </Button>
          </Space>
        )}
        {displayedLogoUrl && (
          <Space direction="vertical" size={8}>
            <Typography.Text type="secondary">Your uploaded Logo</Typography.Text>
            <img
              src={displayedLogoUrl}
              alt="Client logo"
              className="h-32 w-32 rounded border border-gray-200 object-contain bg-white p-2"
            />
            <Button danger onClick={() => void onDeleteLogo()} loading={deleteLogoPending} className="w-fit">
              Delete Logo
            </Button>
          </Space>
        )}
      </Space>
    </Form.Item>
  )
}
